import { render, staticRenderFns } from "./pricemanagement.vue?vue&type=template&id=396d2d9c&scoped=true&"
import script from "./pricemanagement.vue?vue&type=script&lang=js&"
export * from "./pricemanagement.vue?vue&type=script&lang=js&"
import style0 from "./pricemanagement.vue?vue&type=style&index=0&id=396d2d9c&lang=scss&scoped=true&"
import style1 from "./pricemanagement.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./pricemanagement.vue?vue&type=style&index=2&id=396d2d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d2d9c",
  null
  
)

export default component.exports